import { Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastType } from '../../../models/toast.enum';
import { ToastService } from '../../../services/toast.service';
@Component({
	selector: 'app-toasts',
	standalone: true,
	imports: [NgbToastModule],
	templateUrl: './toasts.html',
	styleUrl: './toasts.scss',
	encapsulation: ViewEncapsulation.None
})
export class ToastsComponent {
	ToastType = ToastType;
	readonly toastService = inject(ToastService);
	isScrolling = signal(false);
	private scrollTimer: any;

	onScroll() {
		this.isScrolling.set(true);
		clearTimeout(this.scrollTimer);
		this.scrollTimer = setTimeout(() => {
			this.isScrolling.set(false);
		}, 1000);
	}
}